import { Helmet } from "react-helmet-async";
import { StaticPage } from "../StaticPage/StaticPage";
import { Article } from "../../support.types";
import { SupportArticleNavigation } from "../SupportArticleNavigation/SupportArticleNavigation";

export type Props = {
  article: Article;
  className?: string;
  prev?: Article | null;
  next?: Article | null;
  onNavigationClick: (article: Article) => void;
};

export function SupportArticle({
  article,
  className,
  prev,
  next,
  onNavigationClick,
}: Props) {
  return (
    <>
      <Helmet>
        <title>
          {["Pollinator", "Support", article.title].filter(Boolean).join(" | ")}
        </title>
      </Helmet>
      <StaticPage article={article} className={className} />
      <div className="flex flex-row justify-between mt-16 w-full px-4 md:pr-8 md:pl-0">
        <SupportArticleNavigation
          prev={prev}
          next={next}
          onClick={onNavigationClick}
        />
      </div>
    </>
  );
}

export default SupportArticle;
